module.exports = __webpack_public_path__ + "img/US_BonusDamagevsRanged_ua.32e5ef4d.webp";